//Common analytics store module. app/analytics
import apiWorksheet from '../../../api/anketa'

// Max cache time
const cacheTime = 1000 * 60 * 5 // 5 мин
/**
 * State data
 */
const state = function() {
  return {
    tree: null,
    treeTime: 0
  }
}
/**
 * State getters
 */
const getters = {
  tree(state) {
    return state.tree || []
  },
  statuses(state, getters) {
    let statuses = []
    let nodes = getters.tree.map(it => it)
    while (nodes.length > 0) {
      let node = nodes.pop()
      if (node.element_type === 'status') {
        statuses.push(node)
      }
      const children = node.children || []
      for (let i = 0; i < children.length; i++) {
        nodes.push(children[i])
      }
    }
    return statuses
  },
  statusesHash(_, getters) {
    const statuses = getters.statuses
    let result = {}
    for (let i = 0; i < statuses.length; i++) {
      let p = statuses[i]
      result[p.id] = p
    }
    return result
  }
}
/**
 * State actions
 */
const actions = {
  // Load statuses tree
  loadStatusesTree({ state, commit }, force = false) {
    const time = new Date().getTime()
    if (
      state.tree === null ||
      time - state.treeTime > cacheTime ||
      force === true
    ) {
      return apiWorksheet.getStatusTree().then(tree => {
        commit('SET_TREE', tree)
        commit('SET_TREE_TIME', new Date().getTime())
        return tree
      })
    }
    return Promise.resolve(state.tree)
  },
  orgschemeForms({}, data){
    return apiWorksheet.orgschemeForms(data)
  },
}
/**
 * State mutations
 */
const mutations = {
  // Сброс при смене компании
  RESET(state) {
    state.tree = null
    state.treeTime = 0
  },
  SET_TREE(state, treeData) {
    state.tree = treeData
  },
  SET_TREE_TIME(state, time = 0) {
    state.treeTime = time
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/apps/org/store/common/anketa/index.js